import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FormGroupComponent} from '../../components/form-group/form-group.component';
import {Router, RouterLink} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../services/auth-service/auth.service';
import {FormErrorService} from '../../services/form-error-service/form-error.service';

@Component({
  selector: 'app-forgot-password',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    FormGroupComponent,
    RouterLink
  ],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  private authService = inject(AuthService);
  private formErrorService = inject(FormErrorService);
  private router = inject(Router);
  private toastr = inject(ToastrService);

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  onSubmit() {
    this.authService.forgotPassword(this.form.value.email ?? '')
      .subscribe({
        next: () => {
          this.router.navigate(['login']).then();
          this.toastr.success('Password reset email sent');
        },
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      });
  }
}
